import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { Spinner } from '@alfa-bank/site-spinner';
import { BackgroundV2 as Background } from '@alfa-bank/site-background-v2';
import { ImgV2 as Img } from '@alfa-bank/site-img-v2';
import { Grid } from '@alfa-bank/site-grid-universal';

import styles from './styles/styles.css';
import type { TCashbackCategories } from './models';

export const CashbackCategories: FC<TCashbackCategories> = ({
    CashbackSelector,
    Text,
    cashbackData,
    config,
    isTabs,
    settings,
    status,
}) => {
    if (!settings) return null;

    if (status === 'loading') {
        return (
            <Text styler={{ marginTop: 0, marginBottom: 0 }} tag="div" view="primary-medium">
                <Spinner styler={{ marginRight: 8 }} />
                Загружаем категории кэшбэка
            </Text>
        );
    }

    if (status === 'success' && cashbackData?.categories.length) {
        return <CashbackSelector cashbackList={cashbackData} settings={settings} />;
    }

    if (status === 'error' && isTabs) {
        return (
            <Background
                className={cn(styles.background, styles.external)}
                color="#ffffff"
                styler={{ borderRadius: 24, ...config.backgroundOffset }}
            >
                <Grid
                    className={cn(styles.imgGap, styles.external)}
                    colAutoWidth
                    collapse
                    justify="between"
                >
                    <div>
                        <Text styler={config.titleMargin} tag="div" view={config.titleView}>
                            {settings.unavailableErrorTitle}
                        </Text>

                        <Text kind="secondary" tag="div" view={config.subTitleView}>
                            {settings.unavailableErrorText}
                        </Text>
                    </div>
                    <Img src={settings.iconSrc} {...config.titleImg} />
                </Grid>
            </Background>
        );
    }

    return null;
};
